import {Component, ElementRef, HostListener, Input} from '@angular/core';
import {adoptTipPosition} from "@iv/shared/utils";

@Component({
  selector: 'iv-live-header-cell',
  templateUrl: './header-cell.component.html',
  styleUrls: ['./header-cell.component.scss']
})
export class HeaderCellComponent {

  constructor(
    private elementRef: ElementRef
  ) {
  }

  private _value: any;

  get value() {
    return this._value;
  }

  @Input() set value(value) {
    this._value = value;
  }

  private _mode: any;

  get mode(): any {
    return this._mode;
  }

  @Input() set mode(value: any) {
    this._mode = value;
  }

  @HostListener('mouseover')
  onHover() {
    this.setTipPosition();
  }

  private setTipPosition() {
    const nativeElement: HTMLElement = this.elementRef.nativeElement;
    const tip: HTMLElement = nativeElement.querySelector('.tip');

    if (!tip) return;

    adoptTipPosition(tip);
  }
}
